const IS_VIBRATE_SUPPORTED = !!navigator?.vibrate;

export default IS_VIBRATE_SUPPORTED;
